import { Input as InputBase, InputProps, InputRef } from 'antd';
import { forwardRef } from 'react';
import { ControllerRenderProps, useFormContext } from 'react-hook-form';

interface IProps extends InputProps {
  field?: ControllerRenderProps<any, any>;
}
export const Input = forwardRef<InputRef, IProps>(
  ({ className, field, ...props }, ref) => {
    const context = useFormContext();
    return (
      <InputBase
        ref={ref}
        className={className}
        {...field}
        {...props}
        onBlur={(event: React.FocusEvent<HTMLInputElement, Element>) => {
          if (field?.name) {
            context?.setValue(field.name, event?.target?.value?.trim());
          }
        }}
      />
    );
  },
);
